import { toast } from "sonner";
import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/queries/utils";

import { AdminReference } from "@/queries/admin/references";

export const useResendReferenceRequestEmail = (referenceId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const qc = useQueryClient();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();

      return request<AdminReference>({
        method: "POST",
        path: `/api/admin/references/${referenceId}/resend`,
        token,
      });
    },
    onSettled: (_, error) => {
      if (!error) {
        toast.success(`Reference request sent`);
      } else {
        toast.error(`Error sending a reference request`);
      }
    },
    onSuccess(data) {
      // Update reference
      qc.setQueryData<AdminReference[]>(QueryKeys.adminReferences, (old) => {
        if (!old) {
          return;
        }

        const newData = [...old];

        const idx = newData.findIndex(({ id }) => id === referenceId);
        if (idx === -1) {
          newData.push(data);
        } else {
          newData[idx] = data;
        }

        return newData;
      });
    },
  });

  return {
    resendReferenceRequestEmail: mutate,
    isResendingReferenceRequestEmail: isPending,
    resendReferenceRequestEmailError: error,
  };
};
